export const SET_ACTIVE_PATH = 'MENU_SET_ACTIVE_PATH';
export const SET_ITEMS = 'MENU_SET_ITEMS';
export const SHOW_MENU = 'MAIN_SHOW_MENU';
export const HIDE_MENU = 'MAIN_HIDE_MENU';

export function activateMenuItem(activePath, elementId) {
    return {
        type: SET_ACTIVE_PATH,
        elementId,
        activePath,
    };
}

export function deactivateMenu(elementId) {
    return {
        type: SET_ACTIVE_PATH,
        elementId,
        activePath: [],
    };
}

export function setItems(items, elementId) {
    return {
        type: SET_ITEMS,
        elementId,
        items,
    };
}

export function showMenu(path, elementId) {
    return {
        type: SHOW_MENU,
        elementId,
        path,
    };
}

export function hideMenu(elementId) {
    return {
        type: HIDE_MENU,
        elementId,
    };
}
